import {
  BarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { CardShell } from "@/shared/ui/CardShell";
import { CardMenu } from "@/shared/ui/CardMenu";
import { useChartTheme } from "@/shared/hooks/useChartTheme";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { roiChartConfig } from "./data";

export function ROIChart() {
  const { chartData, activeColor } = roiChartConfig;
  const { tick, inactive } = useChartTheme();
  const { t } = useTranslation();

  return (
    <CardShell>
      <div className="flex items-start justify-between">
        <p className="text-sm font-medium text-muted">{t.crm.roi}</p>
        <CardMenu />
      </div>

      <div className="mt-2">
        <h3 className="text-2xl font-bold text-foreground">{t.crm.roiValue}</h3>
        <p className="mt-0.5 text-sm font-medium text-primary">{t.crm.monthlyChange}</p>
      </div>

      <div className="mt-6">
        <ResponsiveContainer width="100%" height={180}>
          <BarChart data={chartData} barCategoryGap="20%">
            <XAxis
              dataKey="month"
              axisLine={false}
              tickLine={false}
              tick={{ fill: tick, fontSize: 11 }}
              dy={8}
              tickFormatter={(v) => t.common.months[v] ?? v}
            />
            <Bar dataKey="value" radius={[6, 6, 6, 6]} maxBarSize={32}>
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry.active ? activeColor : inactive}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </CardShell>
  );
}
